<script>
    import {createEventDispatcher} from 'svelte';

    export let el = null;
    export let label = '';
    export let placeholder = null;
    export let items = [];
    export let selected = '';
    export let error = null;
	
    // Sort items by position
    $: items.sort(compare);
    $: groups = groupBy(items,"group");

    function compare(a, b) {
		if (a.group && b.group) {
			if (a.group != b.group) {
				return a.group.localeCompare(b.group);
			}
		}
        if (a.pos < b.pos) return -1;
        if (a.pos > b.pos) return 1;
        return 0;
    }

	function groupBy(xs, key) {
	  return xs.reduce(function(rv, x) {
		let groupKey = x[key];
		if (!groupKey) {
			groupKey = "all";
		}
		(rv[groupKey] = rv[groupKey] || []).push(x);
		return rv;
	  }, {});
	};

    const dispatch = createEventDispatcher();

    function onChange() {
        dispatch('change', selected);
    }
</script>

<label bind:this={el}>{label}</label>
<div>
    <select bind:value="{selected}" on:change="{onChange}">
        {#if placeholder}
            <option value="{placeholder.id}">{placeholder.name}</option>
        {/if}
        {#each Object.entries(groups) as [group_key, group]}
			{#if group_key != "all"}
				<optgroup label="{group_key}">
				{#each group as item}
					{#if !item.hidden}
						<option value="{item.id}">{item.name}</option>
					{/if}
				{/each}
				</optgroup>
			{:else}
				{#each group as item}
					{#if !item.hidden}
						<option value="{item.id}">{item.name}</option>
					{/if}
				{/each}
			{/if}
        {/each}
    </select>
</div>
{#if error}
    <div class="bookly-label-error">{error}</div>
{/if}